import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ContentChildren,
  DoCheck,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges
} from '@angular/core';

import 'rxjs/add/operator/distinctUntilChanged';

import { SkyTabComponent } from './tab.component';
import { SkyTabsetAdapterService } from './tabset-adapter.service';
import { SkyTabsetService } from './tabset.service';


export class SkyTabsetComponent
  implements AfterContentInit, AfterViewInit, DoCheck, OnDestroy, OnChanges {
  
  public tabStyle = 'tabs';

  
  public active: number | string;

  
  public newTab = new EventEmitter<any>();

  
  public openTab = new EventEmitter<any>();

  
  public activeChange = new EventEmitter<any>();

  public tabDisplayMode = 'tabs';

  
  public tabs: QueryList<SkyTabComponent>;

  constructor(
    private tabsetService: SkyTabsetService,
    private adapterService: SkyTabsetAdapterService,
    private elRef: ElementRef,
    private changeRef: ChangeDetectorRef
  ) {
  }

  public tabCloseClick(tab: SkyTabComponent) {
    tab.close.emit(undefined);
  }

  public newTabClick() {
    this.newTab.emit(undefined);
  }

  public openTabClick() {
    this.openTab.emit(undefined);
  }

  public windowResize() {
    this.adapterService.detectOverflow();
  }

  public selectTab(newTab: SkyTabComponent) {
    this.tabsetService.activateTab(newTab);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['active'] && changes['active'].currentValue !== changes['active'].previousValue) {
      this.tabsetService.activateTabIndex(this.active);
    }

  }

  public ngAfterContentInit() {
    if (this.active || this.active === 0) {
      this.tabsetService.activateTabIndex(this.active);
    }
    this.tabsetService.activeIndex.distinctUntilChanged().subscribe((newActiveIndex) => {

         // HACK: Not selecting the active tab in a timeout causes an error.
        // https://github.com/angular/angular/issues/6005
        setTimeout(() => {
          if (newActiveIndex !== this.active) {
            this.active = newActiveIndex;
            this.activeChange.emit(newActiveIndex);
          }
        });
    });
  }

  public ngAfterViewInit() {
    this.adapterService.init(this.elRef);

    this.adapterService.overflowChange.subscribe((currentOverflow: boolean) => {
      this.updateDisplayMode(currentOverflow);
    });

    setTimeout(() => {
      this.adapterService.detectOverflow();
      this.updateDisplayMode(this.adapterService.currentOverflow);
      this.changeRef.detectChanges();
    }, 0);
  }

  public ngDoCheck() {
    this.adapterService.detectOverflow();
  }

  public ngOnDestroy() {
    this.tabsetService.destroy();
  }

  private updateDisplayMode(currentOverflow: boolean) {
    this.tabDisplayMode = currentOverflow ? 'dropdown' : 'tabs';
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tabset',
  styles: [`.sky-tabset {
  align-items: center;
  border-bottom: 2px solid #007ca6;
  display: flex;
  list-style-type: none;
  margin: 0;
  overflow: hidden;
  padding: 0 0 0 15px;
  white-space: nowrap;
}

.sky-tabset.sky-tabset-style-wizard {
  border-bottom: none;
  padding-bottom: 10px;
  padding-left: 0;
}

.sky-tabset-btns {
  order: 1;
  padding-left: 10px;
}

.sky-tabset-dropdown {
  order: 0;
  max-width: 100%;
}

.sky-tabset-mode-dropdown {
  /* This line fixes an issue with extra whitespace under collapsed (dropdown) tabs in IE 11. */
  line-height: 0;
}

.sky-tabset-mode-dropdown .sky-tabset-tabs {
  visibility: hidden;
  order: 2;
}

.sky-tabset-tabs {
  order: 0;
  white-space: nowrap;
}

.sky-tabset-btn-new,
.sky-tabset-btn-open {
  color: #007ca6;
}
`],
  template: `<div
    class="sky-tabset" role="tablist"
    [ngClass]="'sky-tabset-mode-' + tabDisplayMode + ' sky-tabset-style-' + tabStyle"
    (window:resize)="windowResize()"
>
  <span class="sky-tabset-dropdown">
    <sky-tab-dropdown
        *ngIf="tabDisplayMode === 'dropdown'"
        [tabs]="tabs"
        (tabClick)="selectTab($event)"
        (closeClick)="tabCloseClick($event)"
    >
    </sky-tab-dropdown>
  </span>
  <span class="sky-tabset-tabs">
    <sky-tab-button
        *ngFor="let tab of tabs; let i = index"
        [tabHeading]="tab.tabHeading"
        [tabHeaderCount]="tab.tabHeaderCount"
        [tabStyle]="tabStyle"
        [active]="tab.active"
        [allowClose]="tab.allowClose"
        [disabled]="tab.disabled"
        (tabClick)="selectTab(tab)"
        (closeClick)="tabCloseClick(tab)"
    ></sky-tab-button>
  </span>
  <span class="sky-tabset-btns">
    <button
        type="button"
        class="sky-btn sky-btn-default sky-tabset-btn-new"
        (click)="newTabClick()"
        [attr.aria-label]="'tab_add' | skyResources"
        *ngIf="newTab.observers.length > 0"
    >
      <i class="fa fa-lg fa-plus-circle"></i>
    </button>
    <button
        type="button"
        class="sky-btn sky-btn-default sky-tabset-btn-open"
        (click)="openTabClick()"
        [attr.aria-label]="'tab_open' | skyResources"
        *ngIf="openTab.observers.length > 0"
    >
      <i class="fa fa-lg fa-folder-open-o"></i>
    </button>
  </span>
</div>
<ng-content></ng-content>
`,
  providers: [SkyTabsetAdapterService, SkyTabsetService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyTabsetService, },
{type: SkyTabsetAdapterService, },
{type: ElementRef, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabStyle': [{ type: Input },],
'active': [{ type: Input },],
'newTab': [{ type: Output },],
'openTab': [{ type: Output },],
'activeChange': [{ type: Output },],
'tabs': [{ type: ContentChildren, args: [SkyTabComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
